import React from 'react'
import { Route, Link } from 'react-router-dom'
import Loadable from 'react-loadable'
import { history } from '../utils/history'
import { RegisteredFeature } from '../utils/RegisteredFeature'
import { FeatureLink } from '../utils/FeatureLink'

const DefaultLoadingScreen = ({ isLoading, error }) => {
  // Handle the loading state
  if (isLoading) {
    return <div>Loading...</div>;
  }
  // Handle the error state
  else if (error) {
    return <div>Sorry, there was a problem loading the page.</div>;
  }
  else {
    return null;
  }
};

const createRoute = (experience: string) => ({ path, loader }: { path: string, loader: any }) => (
  <Route excat path={'/experience/' + experience + '/' + path} component={
    Loadable({
      loader,
      loading: DefaultLoadingScreen
    })
  } />
)

const createLink = (experience: string) => ({ path, loader }: { path: string, loader: any }): FeatureLink => (() => (
  history.push('/experience/' + experience + '/' + path)
))

export const registerFeature = (experience: string) => ({ path, loader }: { path: string, loader: any }): RegisteredFeature => ({
  featureLink: createLink(experience)({ path, loader }),
  registedFeature: createRoute(experience)({ path, loader })
})



// WEBPACK FOOTER //
// ./sampleProject/src/core/feature-loading/registerFeature/index.tsx